import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@material-ui/icons/Delete";
import { colors, IconButton, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useStylesLbl, useStylesTF } from "../../../../St/comps/UseStyle";
import { useStylesAutoSafe } from "../../../../St/Reports/UseStyle";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
        minHeight: 400

    },
}));

export default function SafesTaswyaTable(props) {
    const { paramsSubList, setParamsSubList} = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 16,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#000"
    }


    const onRowDelete = async (rowdata) => {
        var newData = paramsSubList.filter((obj) => obj.barcode.toString() !== rowdata.barcode.toString());
        setParamsSubList([...newData]);
    }
    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    const [rowItem, setRowItem] = useState({});
    const clasTF = useStylesTF();
    const claslbls = useStylesLbl();
    const clasSaf = useStylesAutoSafe();
    const claslbl = useStylesLbl();
    const handleFocus = (e) => e.target.select();

    const handleOpenUpdate = (props, e, row) => {
        var newDataVal = paramsSubList.filter((obj) => obj.editVal === true);
        var newDataPrice = paramsSubList.filter((obj) => obj.editPrice === true);
        var newDataUnit = paramsSubList.filter((obj) => obj.editUnit === true);
        console.log("the rowItem data inve is", rowItem);

        if (rowItem?.no != null) {
            if (rowItem.no == row.no) {
                if (newDataVal.length != 0 && props !== "editVal") {
                    EnterChangeTtems("val2", rowItem, row);
                } else if (newDataPrice.length != 0 && props !== "editPrice") {
                    EnterChangeTtems("Price", rowItem, row);
                }
                else if (newDataUnit.length != 0 && props !== "editUnit") {
                    EnterChangeTtems("val2", rowItem, row);
                    setRowItem({});
                }
            } else {
                if (newDataVal.length != 0 && props !== "editVal") {
                    EnterChangeTtems("val2", rowItem, row);
                } else if (newDataPrice.length != 0 && props !== "editPrice") {
                    EnterChangeTtems("Price", rowItem, row);
                }
                else if (newDataUnit.length != 0 && props !== "editUnit") {
                    EnterChangeTtems("val2", rowItem, row);
                    setRowItem({});
                }
            }
        } else {
            if (props === "editVal") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsSubList];
                dataUpdate[index] = {
                    ...row,
                    editVal: true,
                };
                setParamsSubList([...dataUpdate]);

            } else if (props === "editPrice") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsSubList];
                dataUpdate[index] = {
                    ...row,
                    editPrice: true,
                };
                setParamsSubList([...dataUpdate]);
            }
            else if (props === "editUnit") {
                if (row?.Units?.length > 1) {
                    e.preventDefault();
                    setRowItem({ ...row });
                    const index = row?.no;
                    const dataUpdate = [...paramsSubList];
                    dataUpdate[index] = {
                        ...row,
                        editUnit: true,
                    };
                    setParamsSubList([...dataUpdate]);
                }
            }
        }

    };
    const MathChangIdataTtems = (prop, row) => (event) => {
        let i = {
            res: Number(event.target.value),
            val1: Number(row.val1),
            val2: Number(row.val2),
            Price: Number(row.Price),
            SumPrice: Number(row.SumPrice),
            salePrice: Number(row.salePrice),
            perc: Number(row.perc),
            purchPrice: Number(row.purchPrice),
            diff: Number(row.diff),
            difftot: Number(row.difftot),
        };
        if (prop === "val2") {
            i.diff = i.res - i.val1;
            i.difftot = (i.res - i.val1) * i.perc;
            i.SumPrice = i.diff * i.Price;
            setRowItem({
                ...rowItem,
                [prop]: event.target.value,
                diff: i.diff,
                difftot: i.difftot,
                SumPrice: i.SumPrice,
            });
        } else if (prop === "Price") {
            i.SumPrice = i.diff * i.res;
            setRowItem({
                ...rowItem,
                [prop]: event.target.value,
                SumPrice: i.SumPrice,
            });
        }
    };
    const EnterChangeTtems = (prop, rowItem, row) => {
        let i = {
            val1: Number(rowItem.val1),
            val2: Number(rowItem.val2),
            Price: Number(rowItem.Price),
            SumPrice: Number(rowItem.SumPrice),
            salePrice: Number(rowItem.salePrice),
            perc: Number(rowItem.perc),
            purchPrice: Number(rowItem.purchPrice),
            diff: Number(rowItem.diff),
            difftot: Number(rowItem.difftot),
        };

        if (prop === "val2") {
            const index = row?.no;
            const dataUpdate = [...paramsSubList];
            dataUpdate[index] = {
                ...rowItem,
                val2: i.val2,
                Price: i.Price,
                SumPrice: i.SumPrice,
                def: i.def,
                difftot: i.difftot,
                sum: i.sum,
                editVal: false,
            };
            setParamsSubList([...dataUpdate]);
            setRowItem({});
        }

        if (prop === "Price") {
            const index = row?.no;
            const dataUpdate = [...paramsSubList];
            dataUpdate[index] = {
                ...rowItem,
                val2: i.val2,
                Price: i.Price,
                SumPrice: i.SumPrice,
                def: i.def,
                difftot: i.difftot,
                sum: i.sum,
                editPrice: false,
            };
            setParamsSubList([...dataUpdate]);
            setRowItem({});
        }

    };

    const handleOpenNextUpdate = (row) => {

        let number = row?.no + 1;
        var newDataVal = paramsSubList.filter((obj) => obj.no === number);
        var newData = paramsSubList.find((obj) => obj.no === number);
        if (newDataVal.length != 0) {
        if (newData?.no != null && newData?.no !=0) {
            setRowItem({ ...newData });
            const index = newData?.no;
            const dataUpdate = [...paramsSubList];
            dataUpdate[index] = {
                ...newData,
                editVal: true,
            };
            setParamsSubList([...dataUpdate]);
        }
    }
    };

    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#3f51b5",
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 17,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} hidden={true} align="center">
                            {""}
                        </TableCell>
                        <TableCell style={stylH} hidden={true} align="center">
                            {t("no")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("barcode")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("item")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("unit")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("cost")}
                        </TableCell>

                        <TableCell style={stylH} align="center">
                            {t("quantity-available")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("acual_quantity")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("difference")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("price")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("total")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"Action"}
                        </TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {paramsSubList.map((row) => (
                        <TableRow key={row.barcode}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 17,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center" >{row.no + 1}</TableCell>

                            <TableCell style={stylRo} align="center" >{row.item}</TableCell>
                            <TableCell style={stylRo} align="center" >{row.barcode}</TableCell>

                            <TableCell style={stylRo} align="center" >{row.symbol}</TableCell>
                            <TableCell style={stylRo} align="center" >{row.unitName}</TableCell>

                            {/* <TableCell style={stylRo} align="center" onDoubleClick={(event) => handleOpenUpdate("editUnit", event, row)}
                            >
                                {
                                    row?.editUnit && row?.Units?.length > 1 ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasSaf}
                                            value={row.defUnit}
                                            onChange={(event, newValue) => {
                                                changAutoCurrUnits(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={row?.UnitsTable}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.unitName
                                            }
                                            disableClearable
                                            style={{ backgroundColor: colors.green[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={"الوحدة"}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbls.clrBlackLblS }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row.unitName
                                        )

                                }
                            </TableCell> */}

                            <TableCell style={stylRo} align="center">{parseFloat(row?.purchPrice).toFixed(2)}</TableCell>

                            <TableCell style={stylRo} align="center">{parseFloat(row?.val1).toFixed(2)}</TableCell>

                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editVal", event, row)}
                            >
                                {
                                    row.editVal ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="val2"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="number"
                                                    name="val2"
                                                    onBlur={(e) => EnterChangeTtems("val2", rowItem, row)}
                                                    value={rowItem.val2}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    onChange={MathChangIdataTtems("val2", row)}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("val2", rowItem, row);                                               
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("val2", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.val2)?.toFixed(2)
                                        )}
                            </TableCell>

                            <TableCell style={stylRo} align="center">{parseFloat(row?.diff).toFixed(2)}</TableCell>

                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editPrice", event, row)}
                            >
                                {
                                    row.editPrice ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="Price"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="number"
                                                    name="Price"
                                                    onBlur={(e) => EnterChangeTtems("Price", rowItem, row)}
                                                    value={rowItem.Price}
                                                    onChange={MathChangIdataTtems("Price", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("Price", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("Price", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.Price)?.toFixed(2)
                                        )}
                            </TableCell>


                            <TableCell style={stylRo} align="center" >{parseFloat(row?.SumPrice).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    // onClick={onDelete}

                                    onClick={() => {
                                        onRowDelete(row);
                                    }}>

                                    <DeleteIcon size={"small"} />
                                </IconButton>
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>

            </Table>

        </TableContainer>

    );
}
